import { vizNow, deployAgent, uuid } from "@/views/onboarding/lib/step-by-step-links"

export default {
  deployAgentArn() {
    return deployAgent.creatingIAMWithoutAdmin
  },
  vizNowArn() {
    return vizNow.creatingIAMRoleWithoutAdmin
  },
  uuid
}
